/**
 * The food being up, drawn. See `readiness.ts` for what it means and where the
 * answer comes from.
 *
 * **Not a colour.** A tile in the room already spends green → amber → red on
 * how long a party has been sitting and violet on asking for the bill; a fourth
 * hue on the same tile is a hue nobody can read. This is a filled block of ink
 * with the ground reversed out of it — the loudest thing on a tile, and still
 * the loudest with the colour taken away.
 */

import type { FoodUp } from './readiness';

/** The block on a tile or a tab row. Nothing at all until something is up. */
export function FoodUpTag({ food }: { food: FoodUp }) {
  if (food.ready.length === 0) return null;
  return <span className="up">Food up</span>;
}
